import domReady from '@wordpress/dom-ready';

domReady( () => {
	/* eslint-disable */
    (function () {
        const ebookBody = document.querySelector('.ebook-download-form-body');
        const form = document.getElementById('ebook-download-subscriber-form');
        if (! form) {
            return;
        }

        const button = form.querySelector('button');
        const buttonText = button.innerText;

        form.addEventListener('submit', function (e) {
            e.preventDefault();

            const xhr = new XMLHttpRequest();

            xhr.addEventListener('loadstart', function () {
                button.setAttribute('disabled', true);
                button.innerText = 'Submitting';
            });

            xhr.addEventListener('load', function () {
                const data = JSON.parse(xhr.response);
                ebookBody.classList.add('ebook-download-thank-template')
            });

            xhr.addEventListener('error', function () {
                alert('Error!')
            });

            xhr.addEventListener('loadend', function () {
                button.removeAttribute('disabled');
                button.innerText = buttonText;
            });

            xhr.open(form.method, form.action);
            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            xhr.send(new FormData(form));
        })

    })();
})